import { EMPTY_LIST } from '../../../../constants/common'
import { DocumentTableRow } from '../../../Document'
import { Container } from '../../Container'
import { getTableRowData, TABLE_ROW_VISIBLE_COLUMNS } from '../Documents.mock'

function DocumentsTableRow() {
  return (
    <>
      <Container label='Documents table row'>
        <DocumentTableRow
          Actions={null}
          columns={TABLE_ROW_VISIBLE_COLUMNS}
          item={getTableRowData()}
          selected={EMPTY_LIST}
        />
      </Container>
    </>
  )
}

export default DocumentsTableRow
